import React from 'react';
import { motion } from 'framer-motion';
import { Phone, MapPin, MessageCircle } from 'lucide-react';
import { openWhatsAppQuote } from '../utils/whatsapp';

const FloatingButtons: React.FC = () => {
  const handleCall = () => {
    window.open('tel:+918466055207', '_self');
  };

  const handleLocation = () => {
    window.open('https://maps.google.com/maps?q=Karmanghat,Hyderabad,Telangana', '_blank');
  };

  const handleWhatsApp = () => {
    openWhatsAppQuote();
  };

  return (
    <div className="fixed right-2 sm:right-4 top-1/2 transform -translate-y-1/2 z-50">
      {/* Floating Action Buttons - Always Visible */}
      <motion.div
        initial={{ opacity: 0, x: 50 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ duration: 0.5, delay: 1 }}
        className="space-y-3 sm:space-y-4"
      >
        {/* Call Button */}
        <motion.button
          onClick={handleCall}
          className="bg-gradient-to-r from-green-500 to-emerald-600 hover:from-green-600 hover:to-emerald-700 text-white p-3 sm:p-4 rounded-full shadow-lg hover:shadow-2xl transition-all duration-300 flex items-center space-x-2 group border-2 border-white"
          whileHover={{ scale: 1.15, x: -8, rotate: 5 }}
          whileTap={{ scale: 0.9 }}
          initial={{ scale: 0 }}
          animate={{ scale: 1 }}
          transition={{ delay: 1.1, type: "spring", stiffness: 200 }}
        >
          <Phone className="h-4 w-4 sm:h-5 sm:w-5" />
          <span className="hidden sm:group-hover:block whitespace-nowrap bg-white text-green-600 px-3 py-1 rounded-lg text-sm font-bold shadow-lg mr-2 animate-pulse">
            Call Now
          </span>
        </motion.button>

        {/* Location Button */}
        <motion.button
          onClick={handleLocation}
          className="bg-gradient-to-r from-blue-500 to-cyan-600 hover:from-blue-600 hover:to-cyan-700 text-white p-3 sm:p-4 rounded-full shadow-lg hover:shadow-2xl transition-all duration-300 flex items-center space-x-2 group border-2 border-white"
          whileHover={{ scale: 1.15, x: -8, rotate: -5 }}
          whileTap={{ scale: 0.9 }}
          initial={{ scale: 0 }}
          animate={{ scale: 1 }}
          transition={{ delay: 1.2, type: "spring", stiffness: 200 }}
        >
          <MapPin className="h-4 w-4 sm:h-5 sm:w-5" />
          <span className="hidden sm:group-hover:block whitespace-nowrap bg-white text-blue-600 px-3 py-1 rounded-lg text-sm font-bold shadow-lg mr-2 animate-pulse">
            Find Us
          </span>
        </motion.button>

        {/* WhatsApp Button */}
        <motion.button
          onClick={handleWhatsApp}
          className="bg-gradient-to-r from-green-600 to-teal-700 hover:from-green-700 hover:to-teal-800 text-white p-3 sm:p-4 rounded-full shadow-lg hover:shadow-2xl transition-all duration-300 flex items-center space-x-2 group border-2 border-white"
          whileHover={{ scale: 1.15, x: -8, rotate: 5 }}
          whileTap={{ scale: 0.9 }}
          initial={{ scale: 0 }}
          animate={{ scale: 1 }}
          transition={{ delay: 1.3, type: "spring", stiffness: 200 }}
        >
          <MessageCircle className="h-4 w-4 sm:h-5 sm:w-5" />
          <span className="hidden sm:group-hover:block whitespace-nowrap bg-white text-green-600 px-3 py-1 rounded-lg text-sm font-bold shadow-lg mr-2 animate-pulse">
            WhatsApp
          </span>
        </motion.button>
      </motion.div>

    </div>
  );
};

export default FloatingButtons;
